import React from "react";
import { Busy } from "../presentational/busy";
import { Card } from "../presentational/card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleLeft } from "@fortawesome/pro-light-svg-icons/faArrowCircleLeft";
import ReactGA from "react-ga";
import styles from "../../styles/panels/thankYou.css";
import * as utilities from "../../middleware/utilities";

export class ThankYou extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    ReactGA.pageview("/Spend/ThankYou");
    utilities
      .isCodeValid(this.props.code)
      .then((valid) => {
        if (!valid) {
          this.props.onCodeError();
        }
      })
      .catch(() => {
        this.props.onCodeError();
      });
  }
  renderNavigation() {
    return (
      <div className={styles.navigation}>
        <div className={styles.message}>
          <div
            className={styles.icon}
            onClick={() => {
              ReactGA.event({
                category: "User Action",
                action: "Clicked Back Button",
                label: "/Spend/ThankYou",
              });
              this.props.onBack();
            }}
          >
            <FontAwesomeIcon icon={faArrowCircleLeft} />
          </div>
          {this.props.dictionary.thank_you_header}
        </div>
      </div>
    );
  }
  renderNoteInputs() {
    return (
      <div className={styles.inputs}>
        <div className={styles.group}>
          <label
            className={
              styles.inputLabel +
              (this.props.thankYouNameValid ? "" : " " + styles.error)
            }
          >
            {this.props.dictionary.thank_you_input_thank_you_name}
          </label>
          <input
            className={
              styles.input +
              " " +
              styles.thankYouNameInput +
              (this.props.thankYouNameValid ? "" : " " + styles.error)
            }
            type="text"
            value={this.props.thankYouName}
            onChange={(event) => {
              this.props.onThankYouNameChanged(event.target.value);
            }}
          />
          {this.props.thankYouNameValid ? null : (
            <div className={styles.errorMessage}>
              {this.props.validation.thank_you_input_thank_you_name}
            </div>
          )}
        </div>
        <div className={styles.group}>
          <label
            className={
              styles.inputLabel +
              (this.props.thankYouNoteValid ? "" : " " + styles.error)
            }
          >
            {this.props.dictionary.thank_you_input_thank_you_note}
          </label>
          <textarea
            className={
              styles.input +
              " " +
              styles.thankYouNoteInput +
              (this.props.thankYouNoteValid ? "" : " " + styles.error)
            }
            value={this.props.thankYouNote}
            onChange={(event) => {
              this.props.onThankYouNoteChanged(event.target.value);
            }}
          />
          {this.props.thankYouNoteValid ? null : (
            <div className={styles.errorMessage}>
              {this.props.validation.thank_you_input_thank_you_note}
            </div>
          )}
        </div>
      </div>
    );
  }
  renderAside() {
    return (
      <div className={styles.aside}>
        <div className={styles.commands}>
          <button
            className={styles.button + " " + styles.primary}
            onClick={() => {
              ReactGA.event({
                category: "User Action",
                action: "Clicked Continue Button",
                label: "/Spend/ThankYou",
              });
              this.props.onContinue();
            }}
          >
            {this.props.dictionary.thank_you_continue}
          </button>
          <button
            className={styles.button}
            onClick={() => {
              ReactGA.event({
                category: "User Action",
                action: "Clicked Skip Button",
                label: "/Spend/ThankYou",
              });
              this.props.onSkip();
            }}
          >
            {this.props.dictionary.thank_you_skip}
          </button>
        </div>
        <Card
          src={this.props.donation.image}
          alt={this.props.donation.amount}
        />
      </div>
    );
  }
  render() {
    if (!this.props.code || this.props.busy) {
      return <Busy />;
    } else {
      return (
        <div className={styles.main}>
          {this.renderNavigation()}
          <div className={styles.content}>
            <div className={styles.information}>
              {this.props.dictionary.thank_you_message}
            </div>
            {this.renderNoteInputs()}
          </div>
          {this.renderAside()}
        </div>
      );
    }
  }
}
